import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';
import { servicesData } from '../data/services';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Our Attorneys', path: '/attorneys' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms of Service', path: '/terms-of-service' },
  ];

  return (
    <footer className="bg-[#2E2E2E] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Column */}
          <div>
            <img 
              src="/assets/img/brand/logo-light.webp"
              alt="Federal IP Office" 
              className="h-[4rem] w-auto mb-4"
              data-testid="footer-logo"
            />
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Strategic legal solutions that protect what matters most. Trusted by businesses nationwide.
            </p>
            <div className="flex flex-col space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-white/70">21151 S Western Ave, Torrance, CA 90501</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:Info@federalipoffice.com" className="text-white/70 hover:text-white transition-colors">
                  Info@federalipoffice.com
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href="tel:+18335187356" className="text-white/70 hover:text-white transition-colors">
                  +1 (833) 518-7356 
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-white/70 hover:text-white transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Column 1 */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2">
              {servicesData.slice(0, 6).map((service) => (
                <li key={service.id}>
                  <Link
                    to={service.path}
                    className="text-white/70 hover:text-white transition-colors text-sm"
                    data-testid={`footer-service-${service.id}`}
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Column 2 */}
          <div>
            <h4 className="font-semibold text-lg mb-4">More Services</h4>
            <ul className="space-y-2">
              {servicesData.slice(6).map((service) => (
                <li key={service.id}>
                  <Link
                    to={service.path}
                    className="text-white/70 hover:text-white transition-colors text-sm"
                    data-testid={`footer-service-${service.id}`}
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
              <li className="pt-4">
                <Link
                  to="/contact"
                  className="inline-block border-2 border-white text-white hover:bg-white hover:text-[#2E2E2E] transition-colors px-6 py-2 font-medium text-sm"
                  data-testid="footer-contact-button"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Federal IP Office. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            {legalLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-white/50 hover:text-white transition-colors"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
